import React, { useEffect, useState } from 'react';
import { IoHeadsetOutline } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Badge } from 'antd';
import { addMenu } from '../../redux/slices/menu';
import supportChatService from '../../services/support-chat';

/**
 * Header shortcut to the rider support inbox, with a live unread badge.
 *
 * Same pattern as views/chat/chat-icons.js, but it counts the unread messages
 * of the rider (MySQL) threads instead of the Firestore ones.
 */
const SupportChatIcons = () => {
  const dispatch = useDispatch();
  const [unread, setUnread] = useState(0);

  const goToChat = () => {
    dispatch(
      addMenu({
        url: 'support-chat',
        id: 'support-chat',
        name: 'Support livreurs',
      }),
    );
  };

  useEffect(() => {
    let alive = true;

    const load = () =>
      supportChatService
        .getThreads()
        .then((res) => {
          if (alive) setUnread(res?.total_unread || 0);
        })
        .catch(() => {});

    load();
    const timer = setInterval(load, 30000);

    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, []);

  return (
    <NavLink onClick={goToChat} to='/support-chat' className='chat'>
      <Badge count={unread}>
        <IoHeadsetOutline className='chat-icon' />
      </Badge>
    </NavLink>
  );
};

export default SupportChatIcons;
